export const STANDARD_TEMPLATE = "standard";
export const getComponent = (templateName, componentMap) => {
    if (templateName && templateName.toLocaleLowerCase() in componentMap) {
        return componentMap[templateName.toLocaleLowerCase()];
    }
    return componentMap[STANDARD_TEMPLATE];
};
export const useTemplatedComponent = ({ mainTemplate, fallbackTemplate }, manifest) => {
    if (mainTemplate && mainTemplate.toLocaleLowerCase() in manifest) {
        return manifest[mainTemplate.toLocaleLowerCase()];
    }
    if (fallbackTemplate && fallbackTemplate.toLocaleLowerCase() in manifest) {
        return manifest[fallbackTemplate.toLocaleLowerCase()];
    }
    return manifest[STANDARD_TEMPLATE];
};
